import { render } from "./glossary.md?vue&type=template&id=8c35efae"
import script from "./glossary.md?vue&type=script&lang=js"
export * from "./glossary.md?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__